(function () {
  var VISIBLE_COUNT = 3;

  function setup() {
    var list = document.querySelector('.reviews-io-polaris-widget .R-ContentList');
    if (!list || list.dataset.ghViewMoreInit) return;

    var items = Array.prototype.slice.call(list.children).filter(function (el) {
      return el.classList && el.classList.contains('R-ContentList__item');
    });
    if (items.length <= VISIBLE_COUNT) return;

    list.dataset.ghViewMoreInit = 'true';

    var hiddenItems = items.slice(VISIBLE_COUNT);

    var outer = document.createElement('div');
    outer.className = 'gh-reviews-more';
    var inner = document.createElement('div');
    inner.className = 'gh-reviews-more__inner';
    outer.appendChild(inner);
    hiddenItems.forEach(function (item) {
      inner.appendChild(item);
    });

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gh-reviews-view-more';
    var moreLabel = 'View ' + hiddenItems.length + ' more review' + (hiddenItems.length === 1 ? '' : 's');
    var lessLabel = 'Show fewer reviews';
    button.textContent = moreLabel;

    button.addEventListener('click', function () {
      var expanded = outer.classList.toggle('is-expanded');
      button.textContent = expanded ? lessLabel : moreLabel;
      if (!expanded) {
        outer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    list.appendChild(outer);
    list.insertAdjacentElement('afterend', button);
  }

  var pending = false;
  function scheduleSetup() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      setup();
    });
  }

  var observer = new MutationObserver(scheduleSetup);
  observer.observe(document.body, { childList: true, subtree: true });
  scheduleSetup();
})();